type AppBackgroundColor =
  | "neutral-primary"
  | "neutral-secondary"
  | "violet"
  | null;

function setAppBackgroundColor(color: AppBackgroundColor) {
  const currentColor = document.documentElement.dataset.color;

  if (color) {
    document.documentElement.dataset.color = color;
  } else if (currentColor) {
    delete document.documentElement.dataset.color;
  }
}

export { setAppBackgroundColor, type AppBackgroundColor };
